// extracted by css-extract-rspack-plugin
export default {"Mascot":"Mascot-module__Mascot__hBXut","Animate":"Mascot-module__Animate__QEI6X","Image":"Mascot-module__Image__JcIot","Shadow":"Mascot-module__Shadow__Ug42Q"};